(() => {
  'use strict';

  const KEY = 'ksWishlistV1';
  const RE = /\/products\/[^/?#]+/i;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lastTrigger, toastTimer, observerTimer;

  const heart = (fill = false) => `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" fill="${fill ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const pause = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M5 4.2h3.2v11.6H5zm6.8 0H15v11.6h-3.2z"/></svg>';
  const play = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M6.2 3.8 16 10l-9.8 6.2z"/></svg>';

  const txt = (v) => String(v || '').replace(/\s+/g, ' ').trim();
  const url = (v) => {
    if (!v) return '';
    try {
      const m = new URL(v, location.origin).pathname.match(RE);
      return m ? m[0].replace(/\/+$/, '') : '';
    } catch (_) { return ''; }
  };
  const get = () => {
    try {
      const a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter(x => x && url(x.url)) : [];
    } catch (_) { return []; }
  };
  const idx = (u, a = get()) => a.findIndex(x => url(x.url) === url(u));
  const save = (a) => {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 100))); } catch (_) {}
    sync();
  };

  function cardProduct(card) {
    const link = [...card.querySelectorAll('a[href*="/products/"]')].find(a => url(a.href));
    if (!link) return null;
    const image = card.querySelector('img');
    const title = card.querySelector('.product-card__title,.pcard__title,.ks-new-arrivals__content h3,h3,h4');
    const price = card.querySelector('.price,.product-card__price,.ks-new-arrivals__price,[class*="price"]');
    return {
      url: url(link.href),
      title: txt(title?.textContent) || txt(link.getAttribute('aria-label')) || 'KS Textiles Saree',
      image: image?.currentSrc || image?.src || '',
      price: txt(price?.textContent)
    };
  }

  function pageProduct() {
    const u = url(location.pathname);
    if (!u) return null;
    return {
      url: u,
      title: txt(document.querySelector('#MainContent h1')?.textContent || document.querySelector('meta[property="og:title"]')?.content || document.title),
      image: document.querySelector('meta[property="og:image"]')?.content || document.querySelector('#MainContent img')?.currentSrc || document.querySelector('#MainContent img')?.src || '',
      price: txt(document.querySelector('#MainContent .price')?.textContent || document.querySelector('#MainContent [class*="price"]')?.textContent)
    };
  }

  function toast(message) {
    let el = document.querySelector('.ks-wishlist-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ks-wishlist-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 1800);
  }

  function toggle(product) {
    if (!product?.url) return;
    const items = get();
    const i = idx(product.url, items);
    if (i >= 0) {
      items.splice(i, 1);
      save(items);
      toast('Removed from wishlist');
    } else {
      items.unshift({url:url(product.url), title:txt(product.title) || 'KS Textiles Saree', image:product.image || '', price:txt(product.price)});
      save(items);
      toast('Saved to wishlist');
    }
  }

  function makeButton(product, klass) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = `ks-wishlist-toggle ${klass}`;
    b.dataset.ksWishlistUrl = product.url;
    b.dataset.ksWishlistTitle = product.title || '';
    b.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); toggle(product); });
    return b;
  }

  function updateButton(b, items) {
    const saved = idx(b.dataset.ksWishlistUrl, items) >= 0;
    const state = saved ? 'saved' : 'empty';
    if (b.dataset.ksWishlistState === state) return;
    b.dataset.ksWishlistState = state;
    b.classList.toggle('is-saved', saved);
    b.setAttribute('aria-pressed', saved ? 'true' : 'false');
    b.setAttribute('aria-label', `${saved ? 'Remove' : 'Add'} ${b.dataset.ksWishlistTitle || 'this saree'} ${saved ? 'from' : 'to'} wishlist`);
    const icon = b.querySelector('.ks-wishlist-toggle__icon');
    const label = b.querySelector('.ks-wishlist-toggle__label');
    if (icon) icon.innerHTML = heart(saved); else b.innerHTML = heart(saved);
    if (label) label.textContent = saved ? 'Saved to Wishlist' : 'Add to Wishlist';
  }

  function decorateCards(root = document) {
    root.querySelectorAll?.('.product-card,.product-card--overlay,.ks-new-arrivals__card').forEach(card => {
      if (card.closest('#KSWishlistDrawer') || card.dataset.ksWishlistReady) return;
      const p = cardProduct(card);
      if (!p) return;
      const b = makeButton(p, 'ks-wishlist-toggle--card');
      const media = card.querySelector('.product-card__image-wrapper,.pcard__media');
      const target = media && !/^(A|BUTTON)$/.test(media.tagName) ? media : card;
      target.appendChild(b);
      card.dataset.ksWishlistReady = '1';
    });
  }

  function decorateProductPage() {
    if (document.querySelector('.ks-wishlist-toggle--product')) return;
    const p = pageProduct(), h1 = document.querySelector('#MainContent h1');
    if (!p || !h1) return;
    const b = makeButton(p, 'ks-wishlist-toggle--product');
    b.innerHTML = '<span class="ks-wishlist-toggle__icon"></span><span class="ks-wishlist-toggle__label"></span>';
    h1.insertAdjacentElement('afterend', b);
  }

  function headerButtons(root = document) {
    root.querySelectorAll?.('.header__icons--right .header__buttons').forEach(box => {
      if (box.querySelector('.ks-wishlist-header')) return;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ks-wishlist-header';
      b.setAttribute('aria-label', 'Open wishlist');
      b.innerHTML = `${heart()}<span class="ks-wishlist-header-count" hidden>0</span>`;
      b.addEventListener('click', () => openDrawer(b));
      const cart = box.querySelector('.cart-drawer-button');
      cart ? box.insertBefore(b, cart) : box.appendChild(b);
    });
  }

  function ensureDrawer() {
    if (document.getElementById('KSWishlistDrawer')) return;
    const shell = document.createElement('div');
    shell.id = 'KSWishlistDrawer';
    shell.className = 'ks-wishlist-shell';
    shell.innerHTML = `<button class="ks-wishlist-backdrop" type="button" aria-label="Close wishlist"></button>
      <aside class="ks-wishlist-drawer" role="dialog" aria-modal="true" aria-labelledby="KSWishlistTitle" tabindex="-1">
        <div class="ks-wishlist-head"><div><h2 class="ks-wishlist-title" id="KSWishlistTitle">Your Wishlist</h2><p class="ks-wishlist-subtitle" data-ks-wishlist-summary></p></div><button type="button" class="ks-wishlist-close" aria-label="Close wishlist">×</button></div>
        <div class="ks-wishlist-body"><ul class="ks-wishlist-list" data-ks-wishlist-list></ul>
          <div class="ks-wishlist-empty" data-ks-wishlist-empty hidden><div class="ks-wishlist-empty-icon">${heart()}</div><h3>Save what you love</h3><p>Tap the heart on any saree and it will stay here on this device for an easy return visit.</p><a href="/collections/all">Browse Sarees</a></div>
        </div></aside>`;
    document.body.appendChild(shell);
    shell.querySelector('.ks-wishlist-backdrop').addEventListener('click', closeDrawer);
    shell.querySelector('.ks-wishlist-close').addEventListener('click', closeDrawer);
  }

  function renderDrawer(items = get()) {
    ensureDrawer();
    const shell = document.getElementById('KSWishlistDrawer');
    const list = shell.querySelector('[data-ks-wishlist-list]');
    const empty = shell.querySelector('[data-ks-wishlist-empty]');
    shell.querySelector('[data-ks-wishlist-summary]').textContent = items.length === 1 ? '1 saved saree' : `${items.length} saved sarees`;
    list.replaceChildren();
    if (!items.length) { empty.hidden = false; list.hidden = true; return; }
    empty.hidden = true; list.hidden = false;
    items.forEach(item => {
      const li = document.createElement('li');
      li.className = 'ks-wishlist-item';
      const a = document.createElement('a');
      a.href = item.url; a.setAttribute('aria-label', item.title || 'View saree');
      if (item.image) {
        const img = document.createElement('img');
        img.className = 'ks-wishlist-item-image'; img.loading = 'lazy'; img.alt = item.title || 'Saved saree'; img.src = item.image; a.appendChild(img);
      } else {
        const ph = document.createElement('div'); ph.className = 'ks-wishlist-item-image'; a.appendChild(ph);
      }
      const info = document.createElement('div');
      const t = document.createElement('a'); t.className = 'ks-wishlist-item-title'; t.href = item.url; t.textContent = item.title || 'KS Textiles Saree'; info.appendChild(t);
      if (item.price) { const p = document.createElement('div'); p.className = 'ks-wishlist-item-price'; p.textContent = item.price; info.appendChild(p); }
      const r = document.createElement('button'); r.type = 'button'; r.className = 'ks-wishlist-remove'; r.textContent = 'Remove'; r.setAttribute('aria-label', `Remove ${item.title || 'saree'} from wishlist`);
      r.addEventListener('click', () => { const a = get(), i = idx(item.url, a); if (i >= 0) a.splice(i, 1); save(a); toast('Removed from wishlist'); });
      info.appendChild(r); li.append(a, info); list.appendChild(li);
    });
  }

  function openDrawer(trigger) {
    ensureDrawer(); lastTrigger = trigger || document.activeElement; renderDrawer();
    const shell = document.getElementById('KSWishlistDrawer');
    shell.classList.add('is-open'); document.body.classList.add('ks-wishlist-open');
    requestAnimationFrame(() => shell.querySelector('.ks-wishlist-close')?.focus());
  }
  function closeDrawer() {
    const shell = document.getElementById('KSWishlistDrawer'); if (!shell) return;
    shell.classList.remove('is-open'); document.body.classList.remove('ks-wishlist-open');
    if (lastTrigger?.focus) setTimeout(() => lastTrigger.focus(), 40);
  }

  function sync() {
    const items = get();
    document.querySelectorAll('.ks-wishlist-toggle').forEach(b => updateButton(b, items));
    document.querySelectorAll('.ks-wishlist-header-count').forEach(c => {
      const n = String(items.length);
      if (c.textContent !== n) c.textContent = n;
      c.hidden = !items.length;
    });
    const shell = document.getElementById('KSWishlistDrawer');
    if (shell?.classList.contains('is-open')) renderDrawer(items);
  }

  function enhanceSlideshow(el) {
    if (!el || el.dataset.ksSlideshowQueued) return;
    el.dataset.ksSlideshowQueued = '1';
    let attempts = 0;
    const attach = () => {
      const sw = el.swiper;
      if (!sw?.params) {
        if (++attempts < 60 && el.isConnected) return setTimeout(attach, 100);
        delete el.dataset.ksSlideshowQueued; return;
      }
      if (el.dataset.ksSlideshowEnhanced) return;
      el.dataset.ksSlideshowEnhanced = '1'; el.classList.add('ks-slideshow-enhanced');

      const delay = Number(el.dataset.autoplay || 0);
      const auto = delay > 0 && el.querySelectorAll('.swiper-slide').length > 1;
      let userPaused = false, hoverPaused = false, focusPaused = false, hiddenPaused = document.hidden;

      const apply = () => {
        sw.params.speed = motion.matches ? 0 : 650;
        if (sw.params.autoplay && typeof sw.params.autoplay === 'object') {
          if (delay) sw.params.autoplay.delay = delay;
          sw.params.autoplay.disableOnInteraction = false;
          sw.params.autoplay.pauseOnMouseEnter = true;
          sw.params.autoplay.waitForTransition = true;
        }
        sw.update?.();
      };
      const stop = () => {
        if (!auto || !sw.autoplay) return;
        if (sw.autoplay.pause && sw.autoplay.running) sw.autoplay.pause(); else sw.autoplay.stop?.();
        el.setAttribute('aria-live', 'polite');
      };
      const start = () => {
        if (!auto || !sw.autoplay || userPaused || hoverPaused || focusPaused || hiddenPaused || motion.matches) return;
        sw.autoplay.resume?.() || sw.autoplay.start?.();
        el.setAttribute('aria-live', 'off');
      };
      const toggleUI = (b) => {
        if (!b) return;
        b.innerHTML = userPaused ? play : pause;
        b.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        b.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        b.hidden = motion.matches;
      };

      apply();
      let b = null;
      if (auto) {
        b = document.createElement('button'); b.type = 'button'; b.className = 'ks-slideshow-toggle'; toggleUI(b);
        b.addEventListener('click', () => { userPaused = !userPaused; userPaused ? stop() : start(); toggleUI(b); });
        el.appendChild(b);
        motion.matches ? stop() : el.setAttribute('aria-live', 'off');
      }

      el.addEventListener('mouseenter', () => { hoverPaused = true; stop(); });
      el.addEventListener('mouseleave', () => { hoverPaused = false; start(); });
      el.addEventListener('focusin', e => { if (e.target === b) return; focusPaused = true; stop(); });
      el.addEventListener('focusout', e => { if (e.relatedTarget && el.contains(e.relatedTarget)) return; focusPaused = false; start(); });
      document.addEventListener('visibilitychange', () => { hiddenPaused = document.hidden; hiddenPaused ? stop() : start(); });
      const onMotion = () => { apply(); if (b) b.hidden = motion.matches; motion.matches ? stop() : start(); };
      motion.addEventListener?.('change', onMotion) || motion.addListener?.(onMotion);
    };
    attach();
  }

  function slides(root = document) {
    if (root.matches?.('slideshow-component')) enhanceSlideshow(root);
    root.querySelectorAll?.('slideshow-component').forEach(enhanceSlideshow);
  }

  function refresh(root = document) {
    ensureDrawer(); headerButtons(root); decorateCards(root); decorateProductPage(); slides(root); sync();
  }

  function init() {
    refresh();
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && document.getElementById('KSWishlistDrawer')?.classList.contains('is-open')) closeDrawer(); });
    document.addEventListener('shopify:section:load', e => refresh(e.target || document));
    addEventListener('storage', e => { if (e.key === KEY) sync(); });

    const observer = new MutationObserver(mutations => {
      const relevant = mutations.some(m => {
        const n = m.target?.nodeType === 1 ? m.target : m.target?.parentElement;
        return n && !n.closest?.('#KSWishlistDrawer,.ks-wishlist-toast');
      });
      if (!relevant) return;
      clearTimeout(observerTimer);
      observerTimer = setTimeout(() => refresh(), 120);
    });
    observer.observe(document.body, {childList:true, subtree:true});
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, {once:true}) : init();
})();